module.exports = __webpack_public_path__ + "static/media/Path.d4510e93.svg";